import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['collapseContent', 'icon', 'text'];

  static values = {
    showText: String,
    hideText: String,
  };

  toggleCollapse() {
    this.collapseContentTarget.classList.toggle('collapse-show');
    this.iconTarget.classList.toggle('rotate-180');

    const expanded = this.collapseContentTarget.classList.contains('collapse-show');
    this.textTarget.textContent = expanded ? this.hideTextValue : this.showTextValue;
  }
}
